export default "__VITE_ASSET__NMTE5wmk__"